import { AnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentContext';
import { useContext } from 'react';

export function useAnlageassistentContext() {
  const context = useContext(AnlageassistentContext);

  if (!context) {
    throw new Error(
      'useAnlageassistentContext must be used within an AnlageassistentContextProvider',
    );
  }

  return {
    ctx: context,
  };
}
